const indexItems = [
  { title: '电影频道', count: '3.2万+', desc: '院线大片、经典佳作、独立电影等海量电影资源，覆盖动作、喜剧、科幻、爱情等全类型。', icon: 'ri-film-line', color: 'primary' },
  { title: '电视剧频道', count: '1.8万+', desc: '国产剧、韩剧、美剧、日剧等热门电视剧一网打尽，热门新剧同步更新。', icon: 'ri-tv-2-line', color: 'accent' },
  { title: '综艺频道', count: '8千+', desc: '搞笑综艺、真人秀、脱口秀、音乐节目等精彩综艺内容，周末放松不二之选。', icon: 'ri-emotion-laugh-line', color: 'primary' },
  { title: '动漫频道', count: '1.5万+', desc: '日漫、国漫、欧美动画全覆盖，热门番剧每周更新，二次元爱好者的快乐源泉。', icon: 'ri-ghost-smile-line', color: 'secondary' },
  { title: '纪录片频道', count: '6千+', desc: '自然、历史、人文、科技等题材纪录片，高清画质带来沉浸式观看体验。', icon: 'ri-earth-line', color: 'accent' },
  { title: '香蕉视频专区', count: '热门', desc: '香蕉视频平台独家聚合内容，最新影视资源每日更新，高清流畅观看体验。', icon: 'ri-movie-2-line', color: 'primary' },
  { title: '红桃视频专区', count: '独家', desc: '红桃视频高清资源专属入口，独家片源与蓝光画质内容一站汇集。', icon: 'ri-heart-line', color: 'accent' },
];

const colorStyles: Record<string, { bg: string; text: string; border: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-50/50', text: 'text-primary-700', border: 'border-primary-200/50', iconBg: 'bg-primary-50' },
  accent: { bg: 'bg-accent-50/50', text: 'text-accent-700', border: 'border-accent-200/50', iconBg: 'bg-accent-50' },
  secondary: { bg: 'bg-secondary-50/50', text: 'text-secondary-700', border: 'border-secondary-200/50', iconBg: 'bg-secondary-50' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            内容索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            按频道快速浏览99视频聚合平台的全部内容分类，找到您最感兴趣的影视资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, idx) => {
            const s = colorStyles[item.color];
            const isLast = idx === indexItems.length - 1;
            return (
              <a
                key={idx}
                href={`#${item.title}`}
                onClick={(e) => e.preventDefault()}
                className={`group flex items-start gap-4 p-5 rounded-2xl ${s.bg} border ${s.border} hover:border-primary-200/60 transition-all duration-200 cursor-pointer ${
                  isLast && indexItems.length % 3 !== 0 ? 'lg:col-span-3 lg:max-w-md lg:mx-auto lg:w-full' : ''
                }`}
              >
                <div className={`flex-shrink-0 w-11 h-11 rounded-xl ${s.iconBg} flex items-center justify-center`}>
                  <i className={`${item.icon} ${s.text} text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground-950 text-sm whitespace-nowrap">{item.title}</h3>
                    <span className={`text-xs font-medium ${s.text} whitespace-nowrap`}>{item.count}</span>
                  </div>
                  <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
                <div className="flex-shrink-0 flex items-center">
                  <i className={`ri-arrow-right-line ${s.text} opacity-0 group-hover:opacity-100 transition-opacity text-sm`}></i>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}